<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div style="text-align: center" v-if="failInfo">
					<h1 style="margin-top: 50%;">{{failInfo.message}}</h1>
				</div>
				<div class="" style="overflow-y: auto" v-if="!failInfo">
					<img :src="content" style="width: 100%" @load="imgLoadEnd()" />
					<!-- <img :src="qrCode" style="width: 100%" /> -->

<!--					<img :src="globalConfig.domain.backstage+'/common/uiqr?userId='+userId+'&t='+new Date().getTime()" style="width: 100%" />-->
<!--					<el-button style="padding:5px;" v-if='registerUrl' @click="register()" type="primary">立即使用电子签约</el-button>-->
          <div style="height: 4rem;display: flex;background: #133147;padding: 10px 0 0 0;margin-top: -5px">
            <div style="width: 30%;margin-left: 0.2rem;width: 3rem;height:3rem;margin-top: 0.05rem;padding-left: 0.5rem;padding-top: 0.4rem">
              <img :src="globalConfig.domain.backstage+'/common/uiqr?userId='+userId+'&t='+new Date().getTime()"
                   style="width: 100%;height: 100%"/>
            </div>

            <div style="font-size: 0.4rem;font-family: Source Han Sans SC;font-weight: 400;line-height: 20px;color: #FFFFFF;text-align: left;margin-top: 0.1rem;padding-top: 0.7rem;padding-left: 0.5rem">
              <p style="margin-left:0.1rem">咨询热线</p>
              <p style="border: 1px solid #ffffff;margin:0.5rem 0px 0.5rem 0.1rem"></p>
              <div style="margin-left: 0.1rem">
                <img src="../../../static/img/dhrx.png" style="width: 0.5rem"/>
                <span>{{article.hotline || '400-808-9187'}}</span>
              </div>

            </div>
          </div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import http from '@/http';

	export default {
		name: "ArticleViewContent",
		data() {
			return {
				articleId: this.$route.query.articleId,
				userId: this.$route.query.userId,
				article: {},
				registerUrl: null,
				qrCode: null,
				loading: null,
				content: null,
				failInfo: null
			}
		},
		created: function() {
			this.query()
			this.getLink()
		},
		methods: {
			// 获取地址链接
			getLink() {
				let _this = this
				http.post(this.globalConfig.domain.backstage + "/common/uiqrUrl", {
					userId: this.userId
				}, (response) => {
					let result = response.data;
					if (result.success) {
						_this.registerUrl = result.data
					}
				})
			},
			imgLoadEnd: function() {
				// 图片加载完成，关闭loading
				if (this.loading) {
					this.loading.close();
				}

			},
			share: function() {
				let url = this.globalConfig.domain.backstage + '/common/qr?url=' + this.globalConfig.domain.front +
					'/invite/articleViewContent.html?articleId=' + this.articleId;
				this.$alert(`<div><img src="${url}"/></div>`, '分享', {
					dangerouslyUseHTMLString: true,
					center: true
				});
			},
			query: function() {
				// 开始加载...
				this.loading = this.$loading({
					lock: true,
					text: '内容加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				http.post(this.globalConfig.domain.backstage + "/article/articleContent", {
					articleId: this.articleId
				}, (response) => {
					let result = response.data;
					if (result.success) {
						this.article = result.data;
						this.content = this.globalConfig.domain.backstage + '/article/viewArticleContent?articleId=' + this.article.articleId
						// this.getRegisterUrl();
						this.qrCode = this.globalConfig.domain.backstage + '/common/uiqr?userId=' + this.article.userId + '&t=' + new Date()
							.getTime()
						document.title = this.article.title;
					} else {
						if (this.loading) {
							this.loading.close();
						}
						this.failInfo = {
							message: result.message
						}
					}

				})
			},
			// getRegisterUrl:function () {
			//   http.post(this.globalConfig.domain.backstage+"/articsle/getRegisterUrl",{articleId:this.articleId},(response)=>{
			//     let result = response.data;
			//     if (result.success){
			//       this.registerUrl = result.data;
			//     }
			//   })
			// },
			register: function() {
				window.location.href = this.registerUrl
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/invite/ArticleViewContent.vue